<template>
  <div id="app">
    <el-row>
      <el-col :span="6">
        <div style="width:100%;height:125px;background:#FFF">
          <el-row style="height:100%;text-align:center">
            <el-col :span="4" style="height:100%"></el-col>
            <el-col :span="6" style="height:100%">
              <img
                src="@/svg/logo.png"
                style="height:80px;width:80px;padding-top:15px"
              />
            </el-col>
            <el-col :span="14" style="height:100%;padding-top:15px">
              <h1>西安星年物联网</h1>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="18">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          background-color="#FFFFFF"
          :router="true"
          text-color="#000"
          active-text-color="#4e56c5"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-submenu index="1">
            <template slot="title">产品中心</template>

            <el-submenu index="2-4">
              <template slot="title">智慧水务</template>
              <el-menu-item index="water">智能IC卡表模块</el-menu-item>
              <el-menu-item index="nbWater">NB-Iot水表模块</el-menu-item>
              <el-menu-item index="waterControl">M1卡水控机模块</el-menu-item>
              <el-menu-item index="ultMeter">CPU卡水表电子模块</el-menu-item>
              <!-- <el-menu-item index="ultMeter">超声波水表</el-menu-item>

              <el-menu-item index="humiture">温湿度采集仪</el-menu-item> -->
            </el-submenu>
            <el-submenu index="2-5">
              <template slot="title">热力计量</template>
              <el-menu-item index="hot">超声波热量表模块</el-menu-item>
              <el-menu-item index="nbhot">NB热量表模块</el-menu-item>
            </el-submenu>

            <!-- <el-menu-item index="power">智能供电</el-menu-item>
            <el-menu-item index="gas">智能燃气</el-menu-item> -->
          </el-submenu>
          <el-submenu index="2" popper-class="sub-title">
            <template slot="title">系统平台</template>
            <el-menu-item index="xnmeter">智慧水务管理系统</el-menu-item>
            <el-menu-item index="hotmeter">智能供热管理系统</el-menu-item>
            <el-menu-item index="nbmeter">NB物联网管理系统</el-menu-item>
          </el-submenu>
          <!-- <el-menu-item index="support">企业动态</el-menu-item> -->
          <el-menu-item index="relation">联系我们</el-menu-item>
        </el-menu>
      </el-col>
    </el-row>

    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1'
    }
  }
}
</script>
<style lang="scss">
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background-color: #f1f1f1;
}
.container {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  color: #4e56c5;
}
#app {
  .el-menu-demo {
    padding-left: 12%;
    height: 100px;
    padding-top: 24px;
    .el-submenu__title {
      font-size: 24px;
    }
    li {
      padding-left: 12px;
      font-size: 24px;
    }
  }
}
.product-container {
  padding: 40px 20%;
  margin: 0 auto;
}
</style>
